/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateSpendRuleRequestBody,
  CreateSpendRuleRequestBody$Outbound,
  CreateSpendRuleRequestBody$outboundSchema,
} from "../components/createspendrulerequestbody.js";

export type CreateSpendRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateSpendRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateSpendRuleSecurity = {
  option1?: CreateSpendRuleSecurityOption1 | undefined;
  option2?: CreateSpendRuleSecurityOption2 | undefined;
};

export type CreateSpendRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createSpendRuleRequestBody: CreateSpendRuleRequestBody;
};

/** @internal */
export type CreateSpendRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateSpendRuleSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateSpendRuleSecurityOption1$Outbound,
  CreateSpendRuleSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createSpendRuleSecurityOption1ToJSON(
  createSpendRuleSecurityOption1: CreateSpendRuleSecurityOption1,
): string {
  return JSON.stringify(
    CreateSpendRuleSecurityOption1$outboundSchema.parse(
      createSpendRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateSpendRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateSpendRuleSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateSpendRuleSecurityOption2$Outbound,
  CreateSpendRuleSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createSpendRuleSecurityOption2ToJSON(
  createSpendRuleSecurityOption2: CreateSpendRuleSecurityOption2,
): string {
  return JSON.stringify(
    CreateSpendRuleSecurityOption2$outboundSchema.parse(
      createSpendRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateSpendRuleSecurity$Outbound = {
  Option1?: CreateSpendRuleSecurityOption1$Outbound | undefined;
  Option2?: CreateSpendRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateSpendRuleSecurity$outboundSchema: z.ZodMiniType<
  CreateSpendRuleSecurity$Outbound,
  CreateSpendRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateSpendRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateSpendRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createSpendRuleSecurityToJSON(
  createSpendRuleSecurity: CreateSpendRuleSecurity,
): string {
  return JSON.stringify(
    CreateSpendRuleSecurity$outboundSchema.parse(createSpendRuleSecurity),
  );
}

/** @internal */
export type CreateSpendRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateSpendRuleRequestBody: CreateSpendRuleRequestBody$Outbound;
};

/** @internal */
export const CreateSpendRuleRequest$outboundSchema: z.ZodMiniType<
  CreateSpendRuleRequest$Outbound,
  CreateSpendRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createSpendRuleRequestBody: CreateSpendRuleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createSpendRuleRequestBody: "CreateSpendRuleRequestBody",
    });
  }),
);

export function createSpendRuleRequestToJSON(
  createSpendRuleRequest: CreateSpendRuleRequest,
): string {
  return JSON.stringify(
    CreateSpendRuleRequest$outboundSchema.parse(createSpendRuleRequest),
  );
}
